import React from "react";

const Katha = () => {
  return (
    <div className="flex items-start justify-center">
      <div className="max-w-5xl w-full p-4">
   <h1 className="text-3xl md:text-4xl font-bold text-center text-[#333333] mb-10 border-b-2 pb-2 border-[#b7b7a1]">
          KATHA & TAX TRANSFER
        </h1>
       <p className="text-md text-justify text-[#444] mb-8">Our experienced staff is dedicated to assisting customers in the seamless transfer of revenue records, ensuring that property titles, such as Katha and property tax details, are accurately registered in the name of the purchaser. Working closely with various local authorities, including the BBMP, Panchayat, and Thasildhar, our team expertly navigates the required processes to facilitate timely updates. Under the guidance of our expert lawyers, we provide comprehensive support at every step, from document preparation to liaising with relevant departments. Our commitment is to streamline the transfer process, ensuring that all legal and administrative requirements are met efficiently, thereby empowering our clients with clear and rightful ownership of their properties.</p>
        <ul className="list-disc list-inside text-gray-700 mb-4 space-y-1">
          <li>TRANSFER OF – E-KATHA, E AASHATI, E-SAUTHU, PANI</li>
          <li>PROPERTY TAX UPDATE</li>
        </ul>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-2">Introduction</h2>
          <p className="text-gray-700">
            This subject outlines the procedures, requirements, and implications of Katha registration and tax transfer for immovable property in Karnataka, India. Katha refers to the property tax assessment record, a crucial document for property ownership and tax obligations.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-2">Legal Framework</h2>
          <p className="text-gray-700">
            The process of Katha and tax transfer is governed by various laws and regulations, notably the Karnataka Municipal Corporations Act, 1976, and the Karnataka Land Revenue Act, 1964.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-2">Purpose of Katha</h2>
          <ul className="list-disc list-inside text-gray-700 space-y-1">
            <li>Identification of Property</li>
            <li>Tax Assessment</li>
            <li>Facilitation of Property Transactions</li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-2">Steps for Katha Registration</h2>
          <ol className="list-decimal list-inside text-gray-700 space-y-1">
            <li>
              <strong>Gather Documentation:</strong> Title Deed, Sale Deed, Khata Extracts, Building Plan, ID Proofs
            </li>
            <li>
              <strong>Apply for Katha Registration:</strong> Submit application with documents and fee
            </li>
            <li>
              <strong>Verification by Authorities:</strong> Application review and property inspection
            </li>
            <li>
              <strong>Issuance of Katha:</strong> After approval, receive Katha Certificate
            </li>
          </ol>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-2">Tax Transfer Process</h2>
          <ul className="list-disc list-inside text-gray-700 space-y-1">
            <li>Determine tax due based on property size and usage</li>
            <li>Pay all outstanding dues</li>
            <li>Apply for tax transfer with Katha & payment proof</li>
            <li>Verification and issuance of new tax receipt</li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-2">Implications</h2>
          <ul className="list-disc list-inside text-gray-700 space-y-1">
            <li>Legal Proof of Ownership</li>
            <li>Ensures Tax Compliance</li>
            <li>Required for Bank Loans / Property Deals</li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-2">Conclusion</h2>
          <p className="text-gray-700">
            Understanding the process of Katha registration and tax transfer is crucial for property owners and buyers in Karnataka. Legal compliance ensures smooth ownership transfer and prevents disputes.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">References</h2>
          <ul className="list-disc list-inside text-gray-700 space-y-1">
            <li>Karnataka Municipal Corporations Act, 1976</li>
            <li>Karnataka Land Revenue Act, 1964</li>
            <li>Local municipal guidelines and circulars</li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default Katha;
